import { render, staticRenderFns } from "./CalculatorDialog.vue?vue&type=template&id=22480a4c&scoped=true&"
import script from "./CalculatorDialog.vue?vue&type=script&lang=js&"
export * from "./CalculatorDialog.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorDialog.vue?vue&type=style&index=0&id=22480a4c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22480a4c",
  null
  
)

export default component.exports